"use client"

import { useEffect, useState } from 'react'

const CountUp = ({ start, end, duration = 5 }: {
    start: number;
    end: number;
    duration?: number;
}) => {
    const [count, setCount] = useState(start);

    useEffect(() => {
        if (count < end) {
            const interval = setInterval(() => {
                setCount(count + 1);
                if (count >= end) {
                    clearInterval(interval);
                }
            }, duration * 10);
            return () => clearInterval(interval);
        }
    }, [count, end, duration]);

    return <>{count.toFixed(0)}</>;
}

const Stats = () => {
    return (
        <div className='stats [mask-image:linear-gradient(to_right,transparent,white_10%,white_90%,transparent)]'>
            <div className='stats-box'>
                <div className='text-2xl sm:text-3xl font-bold'><CountUp start={0} end={80} duration={4} /><span className='text-accent font-normal'>+</span></div>
                <div className='text-xs sm:text-sm text-light/60'>Happy Customers</div>
            </div>
            <div className='stats-box'>
                <div className='text-2xl sm:text-3xl font-bold'><CountUp start={0} end={200} duration={3} /><span className='text-accent font-normal'>+</span></div>
                <div className='text-xs sm:text-sm text-light/60'>Projects</div>
            </div>
            <div className='stats-box'>
                <div className='text-2xl sm:text-3xl font-bold'><CountUp start={0} end={5} duration={6} /><span className='text-accent font-normal'>+</span></div>
                <div className='text-xs sm:text-sm text-light/60'>Years of Experience</div>
            </div>
            <div className='hidden xs:block sm:hidden'></div>
            <div className='stats-box'>
                <div className='text-2xl sm:text-3xl font-bold'><CountUp start={0} end={20} duration={5} /><span className='text-accent font-normal'>+</span></div>
                <div className='text-xs sm:text-sm text-light/60'>Cup of Coffee</div>
            </div>
        </div>
    );
};

export default Stats;